// Nikura Custom Code - Product Page Upsell Item List - Start
// GA4 item_list_id / item_list_name for the product-page "Popular add-ons" upsell carousel
// (.misti-upsell-wrapper, slides .misti-product-upsell, checkbox input[name="misti-product-upsell"]).
// Copies Leaf's proven pattern (leaf_cart_upsell.js / leaf_bundle_event.js): push a custom
// dataLayer event whose ecommerce.items[] carry item_id, item_name, price, quantity, index,
// item_list_id, item_list_name. GTM custom-event triggers map each to the STANDARD GA4 event
// (view_item_list / select_item / add_to_cart) with "send ecommerce data from dataLayer".
//   view_item_list_pdp_upsell  - on load, once, all slides (clones excluded)
//   select_item_pdp_upsell     - when a slide's checkbox is ticked
//   add_to_cart_pdp_upsell     - only after a matching /cart/add.js POST returns
//                                successful JSON containing the selected variant(s).
// item_list_id / item_list_name are ALSO pushed top-level (same values) so the served-draft
// verifier (served-event-v1) can bind them as expected_param_keys. No network calls, no
// customer data. Runs only on /products/ pages where the carousel exists.

(function () {
  'use strict';

  if (window.__nkPdpUpsellInstalled) return;
  window.__nkPdpUpsellInstalled = true;

  var LIST_ID = 'pdp_upsell';
  var LIST_NAME = 'Product Page Upsell';
  var WRAPPER = '.misti-upsell-wrapper';
  var SLIDE = '.misti-product-upsell';
  var CHECKBOX = 'input[name="misti-product-upsell"]';

  if (window.location.pathname.indexOf('/products/') !== 0) return;

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function realSlides() {
    var wrapper = document.querySelector(WRAPPER);
    if (!wrapper) return [];
    return Array.prototype.filter.call(wrapper.querySelectorAll(SLIDE), function (s) {
      return !s.classList.contains('splide__slide--clone');
    });
  }

  function slideIndex(slide) {
    var slides = realSlides();
    // clones share the same checkbox id as their original slide
    var box = slide.querySelector(CHECKBOX);
    var id = box ? box.id : '';
    for (var i = 0; i < slides.length; i++) {
      var b = slides[i].querySelector(CHECKBOX);
      if (slides[i] === slide || (id && b && b.id === id)) return i;
    }
    return 0;
  }

  function itemFor(slide, index) {
    var box = slide.querySelector(CHECKBOX);
    var name = text(slide.querySelector('.upsell-name'));
    var priceText = text(slide.querySelector('.upsell-price .text-black') || slide.querySelector('.upsell-price'));
    var m = priceText.replace(/,/g, '').match(/\d+(?:\.\d{1,2})?/);
    var price = m ? Number(m[0]) : NaN;
    if (!name || !box || !box.id || !isFinite(price)) return null;
    return {
      item_id: String(box.id),
      item_name: name,
      price: price,
      quantity: 1,
      index: index,
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME
    };
  }

  function allItems() {
    var items = [];
    realSlides().forEach(function (slide, i) {
      var it = itemFor(slide, i);
      if (it) items.push(it);
    });
    return items;
  }

  function push(eventName, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      ecommerce: ecommerce
    });
  }

  // 1. view_item_list - once per page load, when the carousel is present
  var viewed = false;
  function pushView() {
    if (viewed) return;
    var items = allItems();
    if (!items.length) return;
    viewed = true;
    push('view_item_list_pdp_upsell', { item_list_id: LIST_ID, item_list_name: LIST_NAME, items: items });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushView);
  } else {
    pushView();
  }
  // Splide may mount the carousel after DOM ready; retry briefly, then stop.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    pushView();
    if (viewed || tries >= 10) clearInterval(timer);
  }, 500);

  // 2. select_item - a slide checkbox is ticked
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches(CHECKBOX) || !box.checked) return;
    var slide = box.closest(SLIDE);
    if (!slide) return;
    var item = itemFor(slide, slideIndex(slide));
    if (!item) return;
    push('select_item_pdp_upsell', { item_list_id: LIST_ID, item_list_name: LIST_NAME, items: [item] });
  }, true);

  // 3. Capture intent, then correlate the theme's actual fetch and response.
  // No request is issued here. Return the original promise and response unchanged.
  var pending = null;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    // NOTE: form.id is the <input name="id"> control on Shopify cart forms, so read the attribute.
    if (!form || !form.getAttribute || form.getAttribute('id') !== 'atc') return;
    pending = null;
    var ticked = Array.prototype.filter.call(document.querySelectorAll(CHECKBOX), function (b) { return b.checked; });
    if (!ticked.length) return;
    var seen = {};
    var items = [];
    ticked.forEach(function (box) {
      if (seen[box.id]) return;
      seen[box.id] = true;
      var slide = box.closest(SLIDE);
      if (!slide) return;
      var it = itemFor(slide, slideIndex(slide));
      if (it) items.push(it);
    });
    if (!items.length) return;
    var main = form.querySelector('[name="id"]');
    if (main && main.value) pending = { items: items, main: String(main.value), time: Date.now() };
  }, true);

  var originalFetch = window.fetch;
  window.fetch = function (input, options) {
    var result = originalFetch.apply(this, arguments);
    if (!pending) return result;
    var intent = null;
    var requestItems = [];
    var url;
    try { url = new URL(input instanceof Request ? input.url : String(input), location.href); }
    catch (_) { return result; } // Keep the native fetch rejection for invalid input.
    if (pending && Date.now() - pending.time < 1000 && url.origin === location.origin &&
        url.pathname === '/cart/add.js' && options && options.method === 'POST' &&
        typeof options.body === 'string') {
      try { requestItems = JSON.parse(options.body).items || []; } catch (_) { requestItems = []; }
      if (Array.isArray(requestItems) && requestItems.some(function (it) { return String(it.id) === pending.main; }) &&
          pending.items.every(function (it) { return requestItems.some(function (r) { return String(r.id) === it.item_id; }); })) {
        intent = pending;
        pending = null;
      }
    }
    if (intent) result.then(function (response) {
      if (!response.ok) return;
      return response.clone().json().then(function (body) {
        if (!Array.isArray(body.items)) return;
        var items = [];
        intent.items.forEach(function (selected) {
          var sent = requestItems.find(function (it) { return String(it.id) === selected.item_id; });
          var received = body.items.find(function (it) { return String(it.variant_id || it.id) === selected.item_id; });
          var qty = Number(sent.quantity);
          if (!received || !Number.isInteger(qty) || qty <= 0 || Number(received.quantity) < qty ||
              !Number.isFinite(received.final_price) || received.final_price < 0) return;
          items.push(Object.assign({}, selected, {quantity: qty, price: received.final_price / 100}));
        });
        if (items.length !== intent.items.length) return;
        push('add_to_cart_pdp_upsell', {
          currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'GBP',
          value: Math.round(items.reduce(function (total, it) { return total + it.price * it.quantity; }, 0) * 100) / 100,
          item_list_id: LIST_ID, item_list_name: LIST_NAME, items: items
        });
      }, function () { /* Non-JSON response is not a confirmed add. */ });
    }, function () { /* Aborted transport is not a confirmed add. */ });
    return result;
  };
})();

// Nikura Custom Code - Product Page Upsell Item List - End
